// extracted by css-extract-rspack-plugin
export default {"colorDropdown__control":"colorDropdown__control-IiTsvJ","colorDropdownControl":"colorDropdown__control-IiTsvJ"};